import IssueTypesAddAttributesLeaveModal from './IssueTypesAddAttributesLeaveModal';
import {showIssueTypeUpdatedNotificationAction, updateIssueTypeAction} from '../../../app/actions';
import {
  getIssueTypeForEdit,
  isIssueTypesAdminLeaveAddAttributesModalOpen,
  isUpdatingIssueAttributesMappings,
  isUpdatingIssueTypesAdmin
} from '../../../app/selectors';
import {connect} from '../../../app/connect';

const mapStateToProps = state => {
  const issueTypeForEdit = getIssueTypeForEdit(state);
  return {
    isOpen: isIssueTypesAdminLeaveAddAttributesModalOpen(state),
    isSaving: isUpdatingIssueTypesAdmin(state) || isUpdatingIssueAttributesMappings(state),
    isIssueSubType: issueTypeForEdit && issueTypeForEdit.parentId
  };
};

const mapDispatchToProps = {
  updateIssueTypeAction,
  showIssueTypeUpdatedNotificationAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueTypesAddAttributesLeaveModal);
